import { Icon } from 'Components';
import { APP_ROUTES } from 'Pages/App/App.constants';
import { getLeadPath } from 'Pages/App/AppLayout/AppHeader/AppHeader.helpers';
import { PermissionCode } from 'Services/Api/Users/Types';
import { HELP_DESK_LINK, PUBLIC_RESOURES_URLS } from 'app-config';
import { I18N_LANGUAGE_LIST, TITLE_BY_MENU_KEY } from 'i18n/i18n.constants';

export interface NavItemConfig {
	key: string;
	id?: string;
	label: string;
	icon?: React.ReactNode;
	isExternal?: boolean;
	path?: string;
	children?: Omit<NavItemConfig, 'children'>[];
}

export const PEAKPORTAL_KEY = 'PeakPortal';

export const LANGUAGE_DROPDOWN = I18N_LANGUAGE_LIST.map(code => {
	const title = TITLE_BY_MENU_KEY[code];
	return { key: code, label: title, path: code }
})

export const mainNavItems: NavItemConfig[] = [
	{
		key: PermissionCode.ViewDashboardOverview,
		id: 'dashboard',
		label: 'sidebar.dashboard',
		icon: <Icon type="dashboardIcon" />,
		path: APP_ROUTES.HOME
	},
	{
		key: PermissionCode.VIEW_MY_COURCES,
		id: 'courses',
		label: 'sidebar.courses',
		icon: <Icon type="coursesIcon" />,
		path: APP_ROUTES.COURSES
	},
	{
		key: 'training',
		id: 'training',
		label: 'Training',
		icon: <Icon type="trainingIcon" />,
		children: [
			{
				key: PermissionCode.VIEW_MY_COURCES,
				id: 'my-courses',
				label: 'My Courses',
				icon: <Icon type="coursesIcon" />,
				path: APP_ROUTES.MY_COURSES
			},
			{
				key: PermissionCode.VIEW_ASSIGNMENTS,
				id: 'assignments',
				label: 'Assignments',
				icon: <Icon type="assignmentsIcon" />,
				path: APP_ROUTES.ASSIGNMENTS
			}
		]
	},
	{
		key: PermissionCode.ViewPhishingManager,
		id: 'phishing',
		label: 'sidebar.phishing',
		icon: <Icon type="phishingIcon" />,
		path: APP_ROUTES.PHISHING_MANAGER
	},
	{
		key: 'reports',
		id: 'reports',
		label: 'sidebar.reports.title',
		icon: <Icon type="reportsIcon" />,
		children: [
			{
				key: PermissionCode.ViewDashboardPhishing,
				id: 'phishing',
				label: 'sidebar.reports.phishing',
				icon: <Icon type="phishingMenuIcon" />,
				path: APP_ROUTES.PHISHING
			},
			{
				key: PermissionCode.ViewDashboardElearning,
				id: 'training',
				label: 'sidebar.reports.training',
				icon: <Icon type="trendingArrow" />,
				path: APP_ROUTES.TRAINING
			},
			{
				key: PermissionCode.ViewDashboardSAQCompliance,
				id: 'saq-compliance',
				label: 'sidebar.reports.saqCompliance',
				icon: <Icon type="saqMenuIcon" />,
				path: APP_ROUTES.SAQ_COMPLAINCE
			},
			{
				key: PermissionCode.ViewDashboardScanning,
				id: 'scanning',
				label: 'sidebar.reports.scanning',
				icon: <Icon type="scanningMenuIcon" />,
				path: APP_ROUTES.SCANNING
			},
			{
				key: PermissionCode.ViewDashboardUserActivity,
				id: 'user-activity',
				label: 'sidebar.reports.userActivity',
				icon: <Icon type="users" />,
				path: APP_ROUTES.USER_ACTIVITY
			},
			{
				key: PermissionCode.ViewStandardReports,
				id: 'library',
				label: 'sidebar.reports.library',
				icon: <Icon type="libraryMenuIcon" />,
				path: APP_ROUTES.REPORTS
			},
			{
				key: PermissionCode.ViewStandardReports,
				id: 'saved',
				label: 'sidebar.reports.saved',
				icon: <Icon type="savedMenuIcon" />,
				path: APP_ROUTES.SAVED_REPORTS
			},
			{
				key: PermissionCode.ViewAuditLog,
				id: 'audit-logs',
				label: 'sidebar.reports.auditLogs',
				icon: <Icon type="auditLogMenuIcon" />,
				path: APP_ROUTES.AUDIT_LOG
			}
		]
	},
	{
		key: 'resources',
		id: 'resources',
		label: 'sidebar.resources.title',
		icon: <Icon type="resourceMenuIcon" />,
		children: [
			{
				key: PermissionCode.VIEW_WHITELISTING,
				id: 'whitelisting',
				label: 'sidebar.resources.whitelisting',
				icon: <Icon type="whitelistingMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.phising
			},
			{
				key: PermissionCode.VIEW_POLICIES,
				id: 'policies',
				label: 'sidebar.resources.policies',
				icon: <Icon type="policiesMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.policytemplates
			}
		]
	},
	{
		key: 'settings',
		id: 'settings',
		label: 'sidebar.settings.title',
		icon: <Icon type="settingsIcon" />,
		children: [
			{
				key: PermissionCode.UserManagerScreenView,
				id: 'users',
				label: 'sidebar.settings.users',
				icon: <Icon type="userMenuIcon" />,
				path: APP_ROUTES.USERS
			},
			{
				key: PermissionCode.ViewGroups,
				id: 'groups',
				label: 'sidebar.settings.groups',
				icon: <Icon type="users" />,
				path: APP_ROUTES.GROUPS_LANDING
			},
			{
				key: PermissionCode.ViewOwnershipGroups,
				id: 'ownership',
				label: 'sidebar.settings.ownership',
				icon: <Icon type="ownerShipMenuIcon" />,
				path: APP_ROUTES.OWNERSHIP_GROUPS_LANDING
			},
			{
				key: PermissionCode.ViewRoles,
				id: 'roles',
				label: 'sidebar.settings.roles',
				icon: <Icon type="roleMenuIcon" />,
				path: APP_ROUTES.ROLES
			},
			{
				key: PermissionCode.ViewMappingTenant,
				id: 'mapping',
				label: 'sidebar.settings.mapping',
				icon: <Icon type="mappingMenuIcon" />,
				path: APP_ROUTES.MAPPING
			}
		]
	}
];

export const bottomNavItems: NavItemConfig[] = [
	{
		key: 'language',
		id: 'language',
		label: 'English',
		icon: <Icon type="languageIcon" />,
		children: LANGUAGE_DROPDOWN
	},
	{
		key: 'help',
		id: 'help',
		label: 'sidebar.bottom.help',
		icon: <Icon type="helpIcon" />,
		isExternal: true,
		path: HELP_DESK_LINK
	}
];

export const accountItems: NavItemConfig[] = [
	{
		key: 'profile',
		id: 'profile',
		label: 'sidebar.account.settings',
		icon: <Icon type="profileMenuIcon" />,
		path: APP_ROUTES.PROFILE
	},
	{
		key: 'logout',
		id: 'logout',
		label: 'sidebar.account.signOut',
		icon: <Icon type="logoutMenuIcon" />,
		path: APP_ROUTES.LOGOUT
	}
];

const GET_MENU_NAME_BY_SUBMENU : Record<string, string> = {
	'groups-new': APP_ROUTES.GROUPS_LANDING,
	'groups-deleted': APP_ROUTES.GROUPS_LANDING,
	groups: APP_ROUTES.GROUPS_LANDING,
	'groups-hierarchy': APP_ROUTES.GROUPS_LANDING,
	tenants: APP_ROUTES.GROUPS_LANDING,
	'ownership-groups-new': APP_ROUTES.OWNERSHIP_GROUPS_LANDING,
	'ownership-groups': APP_ROUTES.OWNERSHIP_GROUPS_LANDING
}

export const getRawPath = (pathname: string) => {
	let rawLeadPath = getLeadPath(pathname);

	if(rawLeadPath === "reports") {
		let path = "";
		if(pathname === APP_ROUTES.PHISHING) path = APP_ROUTES.PHISHING;
		else if(pathname === APP_ROUTES.TRAINING) path = APP_ROUTES.TRAINING;
		else if(pathname === APP_ROUTES.SAQ_COMPLAINCE) path = APP_ROUTES.SAQ_COMPLAINCE;
		else if(pathname === APP_ROUTES.SCANNING) path = APP_ROUTES.SCANNING;
		else if(pathname === APP_ROUTES.SAVED_REPORTS) path = APP_ROUTES.SAVED_REPORTS;
		else if(pathname === APP_ROUTES.USER_ACTIVITY) path = APP_ROUTES.USER_ACTIVITY;
		else path = APP_ROUTES.REPORTS;
		rawLeadPath = path.replace('/', '');
	}

	const leadPath = rawLeadPath ? GET_MENU_NAME_BY_SUBMENU[rawLeadPath] || `/${rawLeadPath}` : "";
	return leadPath;
}
